var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { navigateAction } from 'fluxible-router';
import SearchService from '../services/SearchService.client';
import SearchStore, { SearchResultState } from '../stores/SearchStore';
import loadDocument from './loadDocument';
export default function performSearchAction(context, payload, done) {
    var _this = this;
    var query = payload.query, _a = payload.page, page = _a === void 0 ? 1 : _a;
    if (!query || query.length === 0) {
        if (done)
            done();
        return;
    }
    var requestTime = new Date().getTime();
    context.executeAction(navigateAction, { url: "/docs/search?q=".concat(query, "&page=").concat(page) });
    var success = function (response) { return __awaiter(_this, void 0, void 0, function () {
        var responseTime;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(response.results.map(function (_a) {
                        var uri = _a.uri;
                        return loadDocument(context, { url: uri });
                    }))];
                case 1:
                    _a.sent();
                    responseTime = new Date().getTime() - requestTime;
                    SearchService.logSearchEvent({ query: query, page: page, searchQueryUid: response.searchUid, responseTime: responseTime });
                    context.dispatch('SEARCH_RESULT_LOAD_SUCCESS', { query: query, page: page, response: response });
                    if (done)
                        done();
                    return [2 /*return*/];
            }
        });
    }); };
    var failure = function (err) {
        context.dispatch('SEARCH_RESULT_LOAD_FAILURE', { query: query, page: page, err: err });
        if (done)
            done(err);
    };
    // If we've already loaded (or started to load) the result, don't do it again.
    var result = context.getStore(SearchStore).getResult({ query: query, page: page });
    if (result && (result.state === SearchResultState.LOADED || result.state === SearchResultState.LOADING)) {
        return done();
    }
    // If the result hasn't been loaded (or a previous load resulted in
    // an error), try to load it using the SearchService.
    context.dispatch('SEARCH_RESULT_LOADING', { query: query, page: page });
    return SearchService.search({ query: query, page: page }).then(success).catch(failure);
}
